module.exports = __webpack_public_path__ + "static/media/pregnancy-massage.f397b6a7.webp";